import { useLocation, Navigate } from 'react-router-dom'

import { useAuth } from 'contexts/auth/AuthContext'
import { useUser } from 'contexts/UserContext'

const AuthRequired: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const origLocation = useLocation()
  const { currentUser, isLoading: authLoading } = useAuth()
  const { user: tacticUser, loading: tacticUserLoading } = useUser()

  // Just leave loading as a blank page
  if (authLoading || tacticUserLoading) {
    return <></>
  }

  if (
    (!currentUser?.emailVerified && !import.meta.env.VITE_AUTH_UNVERIFIED_EMAIL_LOGIN) ||
    !tacticUser?.id
  ) {
    return (
      <Navigate
        to={`/login?requested=${encodeURIComponent(origLocation.pathname + origLocation.search)}`}
      />
    )
  }

  return children
}

export default AuthRequired
